document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  /* @type {string} API実行先ドメイン */
  const domain = 'secure.moshimo.com';
  /* @type {number} ショップID */
  const msm_shop_id = 818588;

  /** 
   * @type {
   *   number, {
   *     article_id: number,
   *     delivery_date: string,
   *     delivery_request: string,
   *     delivery_timezone_request: string,
   *     variant_id: number
   *   }
   * } 商品別配送データリスト
   */
  let variant_delivery_list = {};  

  /**
   * 全バリエーションID一覧を取得
   *
   * @return {array}
   */
  const _findVariantIdList = () => {
    // Shopify側で出力している商品リストの値を利用
    return meta.product.variants.map((obj) => obj.id);
  }

  /**
   * APIを使って配送データを取得
   * 
   * @return {void}
   */
  const fetchDeliveryList = (() => {
    const variant_id_list = _findVariantIdList();
    const url = 'https://' + domain + '/pp/article/ajax/delivery/officialDeliveryText';
    const param = 'shop_id=' + msm_shop_id + '&v_id_list[]=' + variant_id_list.join('&v_id_list[]=');
    const full_url = url + '?' + param;

    fetch(full_url)
      .then(response => {
        return response.json();
      })
    .then(data => {
      let delivery_list = {};
      data.forEach((variant, index) => {
        delivery_list[variant.variant_id] = data[index];
      });
      variant_delivery_list = delivery_list;
      changeDelivery();
    });
  })();

  /**
   * 配送情報を書き換える
   *
   * @param {number} variant_id バリエーションID
   * @return {void}
   */
  const changeDelivery = () => {
    const input_id = document.querySelector("form.shopify-product-form input[name='id']");
    if (!input_id) {
      throw new Error('input not found.');
      return;
    }
    const variant_id = input_id.value;

    const dd_date = document.querySelector('dd#delivery-date');
    const dd_request = document.querySelector('dd#delivery-request');
    const dd_timezone = document.querySelector('dd#delivery-timezone');
    if (!dd_date || !dd_request || !dd_timezone) {
      throw new Error('dd element not found.');
      return;
    }

    if (variant_delivery_list[variant_id] === undefined) {
      console.error('no variant data.');
      const delivery_div = dd_date.closest('#product-delivery-info');      
      if (!delivery_div) {
        console.error('delivery_div not found.');
        return;
      }
      delivery_div.classList.add('hidden');
      return;
    }

    dd_date.textContent = variant_delivery_list[variant_id]['delivery_date'];
    const delivery_request = variant_delivery_list[variant_id]['delivery_request'];
    // ": " 以前は除去して表示
    dd_request.textContent = delivery_request.substring(delivery_request.indexOf(': ') + 1);
    const delivery_timezone_request = variant_delivery_list[variant_id]['delivery_timezone_request'];
    dd_timezone.textContent = delivery_timezone_request.substring(delivery_timezone_request.indexOf(': ') + 1);
  };

  /**
   * 配送情報変更用のイベントをセット
   * 
   * @return {void}
   */
  const setDeliveryChangeEvent = (() => {
    const sku_box = document.querySelector("div[data-block-type='sku'] variant-sku");
    const mo = new MutationObserver(function() {
      changeDelivery();
    });
    const config = {
      childList: true
    };
    mo.observe(sku_box, config);

  })();

});